import { useQuery } from '@tanstack/react-query';
import { getPermissionsByPartyCode } from './permissions';
import { PermissionsByPartyCode } from "../constants/permission-types";

export const useGetPermissions = (partyCodes: string[]) =>
  useQuery<PermissionsByPartyCode>({
    queryKey: ['permissions', partyCodes],
    queryFn: () => getPermissionsByPartyCode(partyCodes),
  });
